/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {Currency} from "./currency.zod";
import {CustomerOfferStatus} from "./customerOfferStatus.zod";
import {CustomerOfferWorkflow} from "./customerOfferWorkflow.zod";
import {CustomerSelection} from "./customerSelection.zod";
import {Language} from "./language.zod";
import {NoteDto} from "./noteDto.zod";
import {OfferContent} from "./offerContent.zod";
import {OfferEvaluation} from "./offerEvaluation.zod";
import {RepresentativeSelection} from "./representativeSelection.zod";

export const CustomerOfferDto = zod
  .unknown()
  .and(zod.unknown())
  .and(zod.unknown())
  .and(zod.unknown())
  .and(zod.unknown())
  .and(
    zod.object({
      customerOfferId: zod.uuid(),
      expedientId: zod.uuid(),
      offerOrdinal: zod.int().min(1),
      version: zod.int().min(1),
      previousRevisionId: zod.uuid().nullable(),
      name: zod.string(),
      status: CustomerOfferStatus,
      documentSource: zod.enum(["LIVE", "ISSUED"]),
      language: Language,
      currency: Currency,
      createdByUserId: zod.uuid(),
      reviserUserId: zod.uuid().nullable(),
      customer: CustomerSelection,
      representative: zod.union([RepresentativeSelection, zod.null()]),
      content: OfferContent,
      evaluation: OfferEvaluation,
      workflow: CustomerOfferWorkflow,
      notes: zod.array(NoteDto),
    }),
  )
  .describe(
    "Current lifecycle\/Notes belong to revision context. Issued document content, currency, parties, attribution and facts remain frozen; current viewer masking never mutates stored history. Unissued obsolete is LIVE, issued obsolete is ISSUED and workflow records its actual undo target. No authored coefficient, caller issue identity or arbitrary restoration. Coefficient values are independently gated by protected-price observe; lawful unprotected finance and available selling remain visible.",
  );

export type CustomerOfferDto = zod.input<typeof CustomerOfferDto>;
export type CustomerOfferDtoOutput = zod.output<typeof CustomerOfferDto>;
